import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/user/user1.jpg'
import _imports_1 from '../../../assets/images/user/user2.jpg'
import _imports_2 from '../../../assets/images/user/user4.jpg'
import _imports_3 from '../../../assets/images/user/user3.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-3 col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white stats-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative text-primary rounded-1 text-center" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-sterile-box" })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "title text-end" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-dark-emphasis mb-5" }, " Active Projects "),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "fw-black mb-0 me-10" }, "69"),
            /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-success text-badge d-inline-block" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-up-arrow fs-11 lh-1 position-relative top-1" }),
              /*#__PURE__*/_createTextVNode(" 5.5% ")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-medium text-dark-emphasis mt-5" }, [
            /*#__PURE__*/_createTextVNode(" Completed: "),
            /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "25")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mt-15 mt-md-25 mb-5 mb-md-8 d-flex justify-content-between align-items-center" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-secondary" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-black" }, "44"),
          /*#__PURE__*/_createTextVNode(" pending ")
        ]),
        /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-semibold" }, "38%")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "progress",
        role: "progressbar",
        "aria-valuenow": "38",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "progress-bar",
          style: {"width":"38%"}
        })
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-3 col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white stats-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative text-success rounded-1 text-center" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-sugar-cubes" })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "title text-end" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-dark-emphasis mb-5" }, " Total Task "),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "fw-black mb-0 me-10" }, "94"),
            /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-danger text-badge d-inline-block" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-down-arrow fs-11 lh-1 position-relative top-1" }),
              /*#__PURE__*/_createTextVNode(" 3.5% ")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-medium text-dark-emphasis mt-5" }, [
            /*#__PURE__*/_createTextVNode(" Completed: "),
            /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "44")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mt-15 mt-md-25 mb-5 mb-md-8 d-flex justify-content-between align-items-center" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-secondary" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-black" }, "50"),
          /*#__PURE__*/_createTextVNode(" pending ")
        ]),
        /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-semibold" }, "42%")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "progress",
        role: "progressbar",
        "aria-valuenow": "42",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "progress-bar bg-success",
          style: {"width":"42%"}
        })
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-3 col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card mb-25 border-0 rounded-0 bg-white stats-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative text-info rounded-1 text-center" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "flaticon-idea" })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "title text-end" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-dark-emphasis mb-5" }, " Productivity "),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "fw-black mb-0 me-10" }, "90%"),
            /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-success text-badge d-inline-block" }, [
              /*#__PURE__*/_createElementVNode("i", { class: "flaticon-up-arrow fs-11 lh-1 position-relative top-1" }),
              /*#__PURE__*/_createTextVNode(" 9.3% ")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-medium text-dark-emphasis mt-5" }, [
            /*#__PURE__*/_createTextVNode(" Revenue: "),
            /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "$2500")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mt-15 mt-md-25 mb-5 mb-md-8 d-flex justify-content-between align-items-center" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-secondary" }, [
          /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-black" }, "$4504"),
          /*#__PURE__*/_createTextVNode(" more to go ")
        ]),
        /*#__PURE__*/_createElementVNode("span", { class: "text-info-light fw-semibold" }, "50%")
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "progress",
        role: "progressbar",
        "aria-valuenow": "50",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "progress-bar bg-info-light",
          style: {"width":"50%"}
        })
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col-xxl-3 col-sm-6\"><div class=\"card mb-25 border-0 rounded-0 bg-white stats-item\"><div class=\"card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing\"><div class=\"d-flex align-items-center justify-content-between\"><div class=\"icon position-relative text-danger rounded-1 text-center\"><i class=\"flaticon-user-3\"></i></div><div class=\"title text-end\"><span class=\"d-block fw-bold text-dark-emphasis mb-5\"> Total Members </span><div class=\"d-flex align-items-center justify-content-end\"><h3 class=\"fw-black mb-0 me-10\">56</h3><span class=\"fw-bold text-success text-badge d-inline-block\"><i class=\"flaticon-up-arrow fs-11 lh-1 position-relative top-1\"></i> 2.5% </span></div><span class=\"d-block fw-medium text-dark-emphasis mt-5\"> Working: <span class=\"fw-bold\">54</span></span></div></div><div class=\"mt-15 mt-md-20 users-list d-flex align-items-center\"><div class=\"rounded-circle text-center\"><img src=\"" + _imports_0 + "\" class=\"rounded-circle\" alt=\"user\"></div><div class=\"rounded-circle text-center\"><img src=\"" + _imports_1 + "\" class=\"rounded-circle\" alt=\"user\"></div><div class=\"rounded-circle bg-primary-emphasis text-center d-flex align-items-center justify-content-center text-white fs-16 fw-bold\"> P </div><div class=\"rounded-circle text-center\"><img src=\"" + _imports_2 + "\" class=\"rounded-circle\" alt=\"user\"></div><div class=\"rounded-circle bg-primary text-center d-flex align-items-center justify-content-center text-white fs-16 fw-bold\"> S </div><div class=\"rounded-circle text-center\"><img src=\"" + _imports_3 + "\" class=\"rounded-circle\" alt=\"user\"></div><div class=\"rounded-circle bg-secondary text-center d-flex align-items-center justify-content-center text-white fs-14 fw-bold\"> +24 </div></div></div></div></div>", 1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
}